"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyHttpLogInterceptor = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const http_1 = require("@angular/common/http");
class MyHttpLogInterceptor {
    intercept(request, next) {
        return next
            .handle(request).pipe(operators_1.tap((ev) => {
            if (ev instanceof http_1.HttpResponse) {
                // if (ev.status === 204) {
                //     // Temp fix for build error resolve
                //     // ev.body = { error: { errorMessage: 'Currently there is no data available.' }};
                // }
                // Temporarily fix as server #400 error are giving body, we are sending it through 200 and throwing as exception
                if (ev.status === 200) {
                    if (ev.body != null && ev.body !== undefined && ev.body.error !== undefined && ev.body.error && Array.isArray(ev.body.error)) {
                        throw (new http_1.HttpErrorResponse({ status: 400, error: ev.body.error }));
                    }
                    else {
                        return rxjs_1.of(ev);
                    }
                }
                else {
                    return rxjs_1.of(ev);
                }
            }
        }), operators_1.catchError((response) => {
            if (response instanceof http_1.HttpErrorResponse) {
                if (response.status === 200) {
                    const res = new http_1.HttpResponse({
                        body: null,
                        headers: response.headers,
                        status: response.status,
                        statusText: response.statusText,
                        url: response.url
                    });
                    return rxjs_1.of(res);
                }
                if (response.status === 401 || (response.status === 403 && (!request.url.includes('account/v1/login') && !request.url.includes('mfa')))) {
                    if (request.headers.get('authorization') !== null && request.headers.get('authorization') !== undefined
                        && request.headers.get('authorization').indexOf('Bearer') !== -1) {
                        return rxjs_1.throwError({ code: '401' });
                    }
                    if ((request.url !== null && request.url !== undefined)
                        && (request.url.indexOf('express-pay') !== -1 || request.url.indexOf('expressPay') !== -1)) {
                        location.href = '/my_account/personal/express-pay/';
                    }
                    else {
                        location.href = '/my_account/personal/';
                    }
                }
                if (response.status === 500) {
                    if (response.error !== undefined && response.error !== null) {
                        return rxjs_1.throwError(response.error);
                    }
                    else {
                        return rxjs_1.throwError({ code: '500',
                            errorMessage: 'We are unable to process your request. Please try again later or call 1-855-CSPIRE5 (277-4735) for assistance.' });
                    }
                }
                if (response.status === 503) {
                    return rxjs_1.throwError({ code: '503',
                        errorMessage: 'We are unable to process your request. Please try again later or call 1-855-CSPIRE5 (277-4735) for assistance.' });
                }
                if (response.status === 404) {
                    if (request.url !== null && request.url !== undefined) {
                        if (request.url.indexOf('express-pay') !== -1 || request.url.indexOf('expressPay') !== -1) {
                            location.href = '/my_account/personal/express-pay/';
                        }
                        else if (request.url === '/rest-api/account/v1/details') {
                            location.href = '/my_account/personal/';
                        }
                    }
                    else {
                        return rxjs_1.throwError({ errorMessage: 'We are unable to process your request. Please try again later or call 1-855-CSPIRE5 (277-4735) for assistance' });
                    }
                }
                else {
                    if (response.error !== undefined && response.error !== null) {
                        return rxjs_1.throwError(response.error);
                    }
                    else {
                        return rxjs_1.throwError({ errorMessage: 'We are unable to process your request. Please try again later or call 1-855-CSPIRE5 (277-4735) for assistance.' });
                    }
                }
            }
        }));
    }
}
exports.MyHttpLogInterceptor = MyHttpLogInterceptor;
//# sourceMappingURL=interceptor.service.js.map